import * as React from 'react';
import { Performance } from '../../classes/performance';
import { IAltText } from '../../classes/alt-text';
import { formatString } from '../../helpers/string-format';

interface IPerfomanceListProps {
    performancesHeaderTitle: string;
    performancesSectionDescription: string;
    performances: Array<Performance>;
    altText: IAltText;
    showComponent: boolean;
    showPerformancesOnLoad: boolean;
}

class PerformanceList extends React.PureComponent<IPerfomanceListProps, { showPeformances: boolean }>{
    constructor(props: IPerfomanceListProps) {
        super(props);
        this.state = { showPeformances: props.showPerformancesOnLoad };
    }

    render() {
        const useTag = `<title id="expandPerformancesAltText">${formatString(this.props.altText !== null ? this.props.altText.expandSectionArrow : '', [this.props.performancesHeaderTitle])}</title><use xlink:href="#icon-arrow-down" />`;
        return (
            this.props.showComponent ?
                <section className="filters-section performance-list-section">
                    <div className="filters-section-heading">
                        <button className="btn-toggle-full" onClick={() => { this.setState({ showPeformances: !this.state.showPeformances }) }} aria-expanded={this.state.showPeformances ? "true" : "false"}>
                            <h2 className="heading-general">{this.props.performancesHeaderTitle}</h2>
                            <svg className={"filters-section-heading-toggles-icon" + (this.state.showPeformances ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                        </button>
                    </div>

                    <p className="caption-paragraph">{this.getDescription()}</p>
                    {
                        this.state.showPeformances ?
                            <div className="fade-in performance-list-container">
                                {
                                    this.props.performances !== null ?
                                        this.props.performances.map(perf => {
                                            return (
                                                <div key={perf.id} >
                                                    <h2>{perf.title}</h2>
                                                    <p>{perf.dateString} | {perf.timeString}</p>
                                                </div>);
                                        }
                                        ) : null
                                }
                            </div>
                            : null
                    }
                </section>
                : null
        );
    }

    getDescription() {
        const numPerformancesString = this.props.performances.length.toString();
        return this.props.performancesSectionDescription.replace("{0}", numPerformancesString);
    }
}

export default PerformanceList;